import React, { useState, useEffect } from "react";
import DynamicTable from "@atlaskit/dynamic-table";
import { useDispatch } from "react-redux";
import uuid from "react-uuid";
import DeleteIcon from "@atlaskit/icon/core/delete";
import Button from "@atlaskit/button/new";
import { jsonPathTableHeaders } from "../../../../../../../common/constants/core/integration.constants";
import { setEditorSaved } from "../../../../../../../redux/actions/integrationActions";
import CellTextField from "../../../../../../../common/components/CellTextField";
import EmptyState from "@atlaskit/empty-state";
import { Inline } from "@atlaskit/primitives";
import AddIcon from "@atlaskit/icon/core/add";
const JsonVariablePanel = ({ action }) => {
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (action && action.variables) {
      setRows(getRows());
    } else {
      setRows([]);
    }
  }, [action]);

  const createRow = (item, index) => ({
    cells: [
      {
        content: <CellTextField inputValue={item.key} index={index} onChange={onChangeHeader} type="KEY" />,
        key: uuid(),
      },
      { content: <CellTextField inputValue={item.value} index={index} onChange={onChangeHeader} type="VALUE" />, key: uuid() },
      {
        content: getButton(index),
        key: uuid(),
      },
    ],
  });
  const getButton = (index) => {
    return (
      <Button
        onClick={() => onRemoveHeader(index)}
        iconBefore={DeleteIcon}
        aria-label="Remove Header"
      />
    );
  };
  const onChangeHeader = (value, index, type) => {
    switch (type) {
      case "KEY":
        action.variables[index].key = value;
        break;
      case "VALUE":
        action.variables[index].value = value;
        break;
      default:
        break;
    }
    dispatch(setEditorSaved(false));
  };

  const getRows = () => {
    if (action && action.variables) {
      return action.variables.map((h, i) => {
        return createRow(h, i);
      });
    }
    return [];
  };
  const onAddHeader = () => {
    action.variables ? action.variables.push({ key: "", value: "" }) : (action.variables = [{ key: "", value: "" }]);
    setRows(getRows());
    dispatch(setEditorSaved(false));
  };
  const onRemoveHeader = (index) => {
    if (index > -1) {
      action.variables.splice(index, 1);
      setRows(getRows());
      dispatch(setEditorSaved(false));
    }
  };

  return (
    <>
    
      <br />
      <br />
      <Inline alignBlock="center" spread="space-between">
        <b>JSON Path Variables</b>        
          <div className="ihub-sidebar-action-widget-add-action" onClick={onAddHeader}>
            <AddIcon label="" />
              <div className="ihub-sidebar-action-widget-add-action-text">
                Add
              </div>
          </div>
      </Inline>
      <p>Name your variable and use Json path to specify data location. Variable is then accessible via
      <b> &#123;&#123; my_var_name &#125; &#125;</b></p>
      <DynamicTable head={jsonPathTableHeaders} rows={rows ? rows : []} />
      {rows.length === 0 && <EmptyState description="There is no JSON path variables defined yet." />}

    
    </>
  );
};

export default JsonVariablePanel;
